
import React, { useState } from 'react'
import { useNavigate } from "react-router-dom"
import { Form, Input, Card, Button, Popover } from 'antd'
import { UserOutlined, MailOutlined, TabletOutlined, UnlockOutlined } from '@ant-design/icons'

//密码强度
import zxcvbn from 'zxcvbn';
//导入样式
import '@/scss/common.scss'
//引入图片
import leftImage from '@/assets/images/logo_left.jpg'

const Password = () => {
    //路由跳转
    const navigate = useNavigate()

    //密码强度
    const [strength, setStrength] = useState('0')
    const passwordStrength = (e) => {
        setStrength(zxcvbn(e.target.value).guesses_log10)
        console.log(e.target.value,'ddddd')
    }
    const content = (
        <div>
            <meter min="0" max="12" low="4" high="8" optimum="10" value={strength} style={{ width: '100%' }}></meter>
            <div style={{ color: '#7f7f7f' }}>密码长度8-16位,数字、字母、字符至少包含两种</div>
        </div>
    );
    //密码强度

    //登录
    const onFinish = async (values) => {
        console.log(values,'F')
    }

    return (
        <>
            <div className='login'>
                <Card className='login-container'>
                    <div className='left-img'>
                        <img src={leftImage} alt='' />
                    </div>
                    <div className='right-input' style={{ position: 'inherit' }}>
                        <div className='register'>
                            <div className='register-top'>
                                <h2>经营主体应用管理系统</h2>
                                <h3>已有账号，现在就<a onClick={() => { navigate("/login") }} style={{ marginLeft: '15px' }}>登录</a></h3>
                            </div>
                            <div className='password'>
                                <h3>忘记密码</h3>
                                <Form onFinish={onFinish}>
                                    <Form.Item
                                        name="username"
                                        rules={[
                                            {
                                                required: true,
                                                message: '请输入账户/请输入正确的用户名',
                                            },
                                        ]}
                                    >
                                        <Input size="large" placeholder="请输入注册用户名" prefix={<UserOutlined className="icon" />} />
                                    </Form.Item>
                                    <Form.Item name="mobile"
                                        rules={[
                                            {
                                                pattern: /^1[3-9]\d{9}$/,
                                                message: '手机号码格式不对',
                                                validateTrigger: 'onBlur'
                                            },
                                            { required: true, message: '请输入手机号' }
                                        ]}
                                    >
                                        <Input size="large" placeholder="请输入注册手机号" prefix={<TabletOutlined className="icon" />} />
                                    </Form.Item>
                                    <Form.Item >
                                        <div className='fdbj'>
                                            <div className='fdbj-left'>
                                                <Form.Item
                                                    name="code"
                                                    rules={[
                                                        { len: 4, message: '请输入短信验证码', validateTrigger: 'onBlur' },
                                                        { required: true, message: '请输入短信验证码' }
                                                    ]}
                                                    noStyle
                                                >
                                                    <Input size="large" placeholder="请输入验证码" maxLength={4} prefix={<MailOutlined className="icon" />} />
                                                </Form.Item>
                                            </div>
                                            <div className='fdbj-right'>
                                                <Button type="primary" className="login-form-button" style={{ padding: '8px 10px' }}>获取验证码</Button>
                                            </div>
                                        </div>
                                    </Form.Item>
                                    <Popover placement="rightTop" content={content} trigger="click">
                                    <Form.Item
                                        name="password"
                                        rules={[
                                            {
                                                required: true,
                                                message: '请输入密码',
                                            },
                                        ]}
                                     
                                    >
                                       
                                            <Input.Password size="large" placeholder="设置密码|密码长度8-16位,数字、字母、字符至少包含两种" prefix={<UnlockOutlined className="icon" />} onChange={passwordStrength} />
                                       
                                    </Form.Item>
                                    </Popover>
                                    <Form.Item
                                        name="quepassword"
                                        rules={[
                                            {
                                                required: true,
                                                message: '请输确认密码',
                                            },
                                            ({ getFieldValue }) => ({
                                                validator(rule, value) {
                                                    if (!value || getFieldValue('password') === value) {
                                                        return Promise.resolve()
                                                    }
                                                    return Promise.reject('您输入的两次密码不一致')
                                                },
                                            })
                                        ]}
                                        autoComplete="off"
                                    >
                                        <Input.Password size="large" placeholder="请确认密码" prefix={<UnlockOutlined className="icon" />} />
                                    </Form.Item>
                                    <Form.Item>
                                        <Button type="primary" htmlType="submit" className="login-form-button">
                                            确认修改
                                        </Button>
                                    </Form.Item>
                                </Form>
                            </div>

                        </div>
                    </div>
                </Card>
            </div>
        </>
    )
}

export default Password